import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { StackView, Box, Icon } from '@planningcenter/tapestry-react'
import { Text } from '../shared/typography'
import { colors } from '../theme'

export default function AppLink({ name, icon, background, beta, to }) {
  return (
    <StackView
      background="white"
      as={RouterLink}
      to={to}
      css={{
        transition: '0.2s all ease',
        boxShadow: `0 3px 15px 0 ${colors['grey-4']}`,
        border: `1px solid ${colors['grey-3']}`,
        borderRadius: 8,
        overflow: 'hidden',
        textDecoration: 'none',

        '&:hover': {
          boxShadow: `0 4px 25px 0 ${colors['grey-5']}`,
        },
      }}
    >
      <StackView
        axis="horizontal"
        mediaQueries={{
          md: {
            axis: 'vertical',
          },
        }}
      >
        <StackView
          backgroundColor={background}
          padding={4}
          alignment="center"
          distribution="center"
          axis="vertical"
        >
          <Box
            width="48px"
            height="48px"
            mediaQueries={{
              md: {
                width: '80px',
                height: '80px',
              },
            }}
          >
            <Icon name={icon} fill="white" height="100%" width="100%" />
          </Box>
        </StackView>
        <StackView
          distribution="center"
          alignment="center"
          backgroundColor="white"
          padding={2}
        >
          <Text
            color={colors['grey-8']}
            weight={500}
            size={1}
            paddingLeft={1}
            mediaQueries={{
              md: {
                paddingLeft: 0,
                size: 2,
              },
            }}
          >
            {name} {beta && <span style={{ fontWeight: 300 }}>(beta)</span>}
          </Text>
        </StackView>
      </StackView>
    </StackView>
  )
}
